import { ExpectedEffectiveValues } from '@hkm/shared/effectiveValues/expectedEffectiveValues';

export const AttendantEffectiveValues: ExpectedEffectiveValues = new Map()
  .set('enableAttendantMobileApplication', true);



// WEBPACK FOOTER //
// ./src/components/Attendant/shared/config/attendantEffeectiveValues.ts